import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';

let store;

export default (() => {
  if (!store) {
    const composeEnhancers =
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    store = createStore(rootReducer);
  }

  return store;
})();
